import React from 'react'
import { Route } from 'react-router-dom'
import asyncComponent from './utils/AsyncComponent'
import SwitchOr404 from './components/Router/SwitchOr404'

const AsyncAssessmentRoutes = asyncComponent(() => import('./assessment/AssessmentRoutes'))
const AsyncReportRoutes = asyncComponent(() => import('./report/ReportRoutes'))
const AsyncAdminRoutes = asyncComponent(() => import('./admin/AdminRoutes'))

const Routes = () =>
  <SwitchOr404>
    <Route path='/assessment/' component={AsyncAssessmentRoutes}/>
    <Route path='/report' component={AsyncReportRoutes}/>
    <Route path='/admin' component={AsyncAdminRoutes}/>
  </SwitchOr404>

export default Routes
